/**
 * @file PaymentStatusOverlay/styled.tsx
 * @description Styled components for PaymentStatusOverlay
 *
 * Task 21.2: PaymentStatusOverlay component styles
 */

import styled, { keyframes } from 'styles/styled';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const OverlayWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(21, 25, 30, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
  padding: 24px;
`;

export const Message = styled.h3`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 16px 0 8px;
  text-align: center;
`;

export const SubMessage = styled.p`
  color: #888888;
  font-size: 14px;
  margin-bottom: 24px;
  text-align: center;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(82, 211, 129, 0.2);
  border-top-color: #52D381;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 8px;
`;

export const ErrorIconWrapper = styled(IconWrapper)`
  background: rgba(255, 68, 68, 0.1);
  color: #ff4444;
`;

export const WarningIconWrapper = styled(IconWrapper)`
  background: rgba(255, 204, 0, 0.1);
  color: #ffcc00;
`;

export const InfoIconWrapper = styled(IconWrapper)`
  background: rgba(82, 211, 129, 0.1);
  color: #52D381;
`;

export const ActionButton = styled.button`
  background: #52D381;
  color: #15191e;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;
